import script from "./SocialSharingInline.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialSharingInline.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__